import React, { Component } from "react";
import NotMe from "../../../components/NotMe";
import AddressDisplay from "../../../components/AddressDisplay";
import { connect } from "react-redux";
import { notMe } from "../../../redux/actions/lot";
import { goNext, disableBack } from "../../../redux/actions/stepper";
import { checkAddressEditFlag } from "../../../redux/actions/address";
import Form from "../../../components/form/Form";
import CircularProgress from "@material-ui/core/CircularProgress";
import renderIf from "../../../utils/renderIf";

class BasicLotDetails extends Component {
  componentWillMount() {
    this.props.disableBack();
  }

  onChangeAddressClick = check => {
    this.props.checkAddressEditFlag();
    this.props.goNext(check);
  };

  changeName = (stepFields, fields) => {

    if(fields.sellerType.value !== 'C'){
      return stepFields
    }
    const objIndex = stepFields.findIndex(obj => obj.name === 'sellerName');

    // make new object of updated object.   
    const updatedObj = { ...stepFields[objIndex], label: 'Donation Company'};

    // make final new array of objects by combining updated object.
    return [
      ...stepFields.slice(0, objIndex),
      updatedObj,
      ...stepFields.slice(objIndex + 1),
    ];
  }

  render() {
    const {
      stepFields,
      fields,
      isPartialMatch,
      notMe,
      goNext,
      apiProcessing,
      stepTitle,
      stepIntroText
    } = this.props;
    return (
      <div>
        {renderIf(Object.keys(fields).length === 0)(
          <CircularProgress className="load-spinner" />
        )}
        {renderIf(Object.keys(fields).length)(
          <div>
            {renderIf(stepTitle)(
            <div className="intro-title">{stepTitle}</div>
            )}
            {renderIf(stepIntroText)(
            <div className="intro-text">{stepIntroText}</div>
            )}
            <div className="step-form">
              <Form fieldsStructure={this.changeName(stepFields, fields)} fields={fields} />
              
              <AddressDisplay
                addressLine1={
                  fields["addressLine1"] ? fields["addressLine1"].value : ""
                }
                addressLine2={
                  fields["addressLine2"] ? fields["addressLine2"].value : ""
                }
                city={fields["city"] ? fields["city"].value : ""}
                zip={fields["zip"] ? fields["zip"].value : ""}
                state={fields["state"] ? fields["state"].value : ""}
                isPartialMatch={isPartialMatch}
                onChangeAddressClick={this.onChangeAddressClick}
                disableClick={apiProcessing}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  fields: state.pickupForm.fields,
  isPartialMatch: state.address.geoSuggestAddress.isPartialMatch,
  apiProcessing: state.ui.apiProcessing
});

const mapDispatchToProps = {
  notMe,
  goNext,
  disableBack,
  checkAddressEditFlag
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BasicLotDetails);



// WEBPACK FOOTER //
// ./src/containers/PickupForm/steps/BasicLotDetails.js